import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ComparisonTable.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get } from '../../utils';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import Select from "react-select";
import { tealiumClickFunc } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
var MAX_TABLET_WIDTH = "974px";
var getCountOfColumns = function getCountOfColumns(variant) {
  switch (variant) {
    case "Two Columns":
      return 2;
    case "Three Columns":
      return 3;
    case "Four Columns":
      return 4;
    default:
      return 0;
  }
};
var sortItems = function sortItems(targetItems, compareItems) {
  var priorityMap = new Map(targetItems.map(function (item, index) {
    return [item.id, index];
  }));
  var sortedItems = compareItems.sort(function (a, b) {
    var priorityIndexA = priorityMap.get(a.id);
    var priorityIndexB = priorityMap.get(b.id);
    if (priorityIndexA !== undefined && priorityIndexB !== undefined) {
      return priorityIndexA - priorityIndexB;
    } else if (priorityIndexA !== undefined) {
      return -1;
    } else if (priorityIndexB !== undefined) {
      return 1;
    } else {
      return a.name.localeCompare(b.name);
    }
  });
  return sortedItems;
};
var ComparisonTable = function ComparisonTable(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var count = getCountOfColumns(params.variant);
  var targetItems = get(fields, "data.item.compare.targetItems", []).filter(function (el) {
    return get(el, "comparisonName.jss.value");
  });
  var items = get(fields, "data.item.children", []).filter(function (el) {
    return get(el, "comparisonName.jss.value");
  });
  var slicedTargetItems = sortItems(targetItems, items).slice(0, count);
  var _useState = useState(slicedTargetItems.map(function (el) {
      return {
        value: el.id,
        label: el.comparisonName.jss.value
      };
    })),
    _useState2 = _slicedToArray(_useState, 2),
    selectedItems = _useState2[0],
    setSelectedItems = _useState2[1];
  var getSelectedItem = function getSelectedItem(index) {
    return items.find(function (el) {
      return el.id === selectedItems[index].value;
    });
  };
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var rowsNames = Array.from(Array(10).keys()).map(function (num) {
    return get(fields, "data.item.rowTitle".concat(num + 1, ".jss.value"), "");
  });
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "comparison-table comparison-table__".concat(targetItems.length, "-items module-group")
  }, items.length > 1 && rowsNames.some(function (el) {
    return el;
  }) && /*#__PURE__*/React.createElement("div", null, items.length > 2 && /*#__PURE__*/React.createElement("div", {
    className: "comparison-table__selects ".concat(items.length === slicedTargetItems.length ? "comparison-table__selects--desktop-hidden" : "")
  }, slicedTargetItems.map(function (_, i) {
    return /*#__PURE__*/React.createElement(Select, {
      key: i,
      value: selectedItems[i],
      name: "comparison-table-".concat(i),
      id: "comparison-table-".concat(i),
      options: items.map(function (el) {
        return {
          label: el.comparisonName.jss.value,
          value: el.id
        };
      }),
      className: "comparison-table__select",
      classNamePrefix: "select-dropdown",
      onChange: function onChange(el) {
        return setSelectedItems(selectedItems.map(function (item, j) {
          if (i === j) {
            if (el) {
              tealiumClickFunc({
                eventAct: eventsAnalytics["dropDownClickAnalytics"].eventAct || params.eventAct,
                eventCat: eventsAnalytics["dropDownClickAnalytics"].eventCat || params.eventCat,
                eventLab: eventsAnalytics["dropDownClickAnalytics"].eventLab || params.eventLab,
                eventName: eventsAnalytics["dropDownClickAnalytics"].eventName || params.eventName
              }, el.label);
              return el;
            } else {
              return {
                label: "",
                value: ""
              };
            }
          } else if (el && el.value === item.value) {
            return selectedItems[i];
          } else {
            return item;
          }
        }));
      },
      isMulti: false
    });
  })), items.length === slicedTargetItems.length && /*#__PURE__*/React.createElement("div", {
    className: "comparison-table__item-headers ".concat(slicedTargetItems.length !== 2 ? "comparison-table__item-header--mobile-hidden" : "")
  }, selectedItems.map(function (selectedItem, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "comparison-table__static-item-name"
    }, selectedItem.label);
  })), /*#__PURE__*/React.createElement("table", {
    className: "comparison-table__table"
  }, /*#__PURE__*/React.createElement("colgroup", null, slicedTargetItems.map(function (_, i) {
    return /*#__PURE__*/React.createElement("col", {
      key: i,
      className: "comparison-table__col-".concat(i)
    });
  })), /*#__PURE__*/React.createElement("tbody", null, rowsNames.map(function (rowName, i) {
    return rowName ? /*#__PURE__*/React.createElement("tr", {
      key: i,
      className: "comparison-table__row"
    }, selectedItems.map(function (_, j) {
      return /*#__PURE__*/React.createElement("td", {
        key: j,
        className: "comparison-table__cell"
      }, rowName && /*#__PURE__*/React.createElement("div", {
        className: "comparison-table__info-label"
      }, rowName), getSelectedItem(j)["row".concat(i + 1)].jss.value ? /*#__PURE__*/React.createElement(RichText, {
        field: getSelectedItem(j)["row".concat(i + 1)].jss,
        className: "comparison-table__info",
        tag: "div"
      }) : "—");
    })) : null;
  }), /*#__PURE__*/React.createElement("tr", {
    className: "comparison-table__btns-row"
  }, selectedItems.map(function (_, i) {
    return /*#__PURE__*/React.createElement("td", {
      key: i,
      className: "comparison-table__cell"
    }, getSelectedItem(i).cTALink.jss.value.href && getSelectedItem(i).ctaLabel.jss.value && /*#__PURE__*/React.createElement("a", {
      href: getSelectedItem(i).cTALink.jss.value.href,
      onClick: function onClick() {
        return tealiumClickFunc({
          eventAct: eventsAnalytics["buttonClickAnalytics"].eventAct || params.eventAct,
          eventCat: eventsAnalytics["buttonClickAnalytics"].eventCat || params.eventCat,
          eventLab: eventsAnalytics["buttonClickAnalytics"].eventLab || params.eventLab,
          eventName: eventsAnalytics["buttonClickAnalytics"].eventName || params.eventName
        }, [selectedItems[i].label, getSelectedItem(i).ctaLabel.jss.value]);
      },
      className: "comparison-table__cta btn btn-primary"
    }, getSelectedItem(i).ctaLabel.jss.value));
  })))))));
};
export default ComparisonTable;
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
var commonStyles = "c1kc4jvl";
var rtlStyles = "r1pmso1a";
var ltrStyles = "l12sjoj3";